<ng-template #tooltipContent>
    <div class="PgMapLinkComponent" (mouseenter)="keepOpen(t)" (mouseleave)="closeWithDelay(t)">
        <div class="PgMapLinkComponent-Title">{{ 'pg-map-link.title' | locTranslate }}</div>

        @if(coordinates) {
            <div class="PgMapLinkComponent-Text">
                <div class="PgMapLinkComponent-Text-Item">
                    <a href="https://maps.google.com/?q={{ encodeURIComponent(coordinates || address) }}" target="_blank">
                        <i class="fa-brands fa-fw fa-google me-2"></i>
                        <span>Google Maps</span>
                    </a>
                </div>
                <div class="PgMapLinkComponent-Text-Item">
                    <a href="https://maps.apple.com/?q={{ encodeURIComponent(coordinates || address) }}" target="_blank">
                        <i class="fa-brands fa-fw fa-apple me-2"></i>
                        <span>Apple Maps</span>
                    </a>
                </div>
            </div>
        }
    </div>
</ng-template>

<span [ngbTooltip]="tooltipContent" triggers="manual" #t="ngbTooltip" (mouseup)="stopEvent($event);" (click)="stopEvent($event); keepOpen(t);" (mouseleave)="closeWithDelay(t)" [container]="tooltipContainer" tooltipClass="PgMapLinkComponent-Tooltip">
    <a href="javascript:void(0)">
        <ng-content></ng-content>
    </a>
</span>
